var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "scope-resume-detail"
  }, [_c('div', {
    staticClass: "fixed-bar"
  }, [_c('div', {
    staticStyle: {
      "margin-left": "230px",
      "margin-right": "30px"
    }
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "space-between",
      "align": "middle"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [(_vm.personalData.name) ? _c('h1', {
    staticClass: "fixed-bar-title pull-left"
  }, [_vm._v(_vm._s(_vm.personalData.name) + " - " + _vm._s(_vm.positionData.name))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "pull-left"
  }, [(!_vm.isEdit) ? [_c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        _vm.isEdit = !_vm.isEdit
      }
    }
  }, [_vm._v("编辑")]), _vm._v(" "), (_vm.showCloseBtn) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": _vm.$win.close
    }
  }, [_vm._v("关闭")]) : _vm._e()] : [_c('el-button', {
    staticClass: "f-edit",
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.submitAll
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('el-button', {
    staticClass: "f-edit",
    on: {
      "click": _vm.cancelEdit
    }
  }, [_vm._v("取消")])]], 2)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 14
    }
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "end"
    }
  }, [(_vm.from === 'entryList') ? [_c('el-button', {
    attrs: {
      "icon": "el-icon-my-queding color-success",
      "type": "success",
      "plain": true
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus(_vm.id, 'pass', null, '入职')
      }
    }
  }, [_vm._v("入职\n                            ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "icon": "el-icon-my-guanbi color-danger",
      "type": "danger",
      "plain": true
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus(_vm.id, 'notPass', null, '毁约')
      }
    }
  }, [_vm._v("毁约\n                            ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "icon": "el-icon-my-huitui color-info",
      "type": "info",
      "plain": true
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus(_vm.id, 'back')
      }
    }
  }, [_vm._v("回退\n                            ")])] : (_vm.from === 'interviewList' || _vm.from === 'resumeList') ? [_c('el-button', {
    attrs: {
      "icon": "el-icon-my-queding color-success",
      "type": "success",
      "plain": true
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus(_vm.id, 'pass')
      }
    }
  }, [_vm._v("通过\n                            ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "icon": "el-icon-my-daiding color-warning",
      "type": "warning",
      "plain": true
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus(_vm.id, 'undetermined')
      }
    }
  }, [_vm._v("待定\n                            ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "icon": "el-icon-my-guanbi color-danger",
      "type": "danger",
      "plain": true
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus(_vm.id, 'notPass')
      }
    }
  }, [_vm._v("淘汰\n                            ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "icon": "el-icon-my-lahei color-purple",
      "type": "purple",
      "plain": true
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus(_vm.id, 'lh')
      }
    }
  }, [_vm._v("拉黑\n                            ")]), _vm._v(" "), (_vm.basePath === '/employ') ? _c('el-button', {
    attrs: {
      "icon": "el-icon-my-guanbi color-danger",
      "type": "danger",
      "plain": true
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus(_vm.id, 'fq')
      }
    }
  }, [_vm._v("放弃\n                            ")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    attrs: {
      "icon": "el-icon-my-huitui color-info",
      "type": "info",
      "plain": true
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus(_vm.id, 'back')
      }
    }
  }, [_vm._v("回退\n                            ")]), _vm._v(" "), (_vm.basePath === '/employ') ? _c('el-button', {
    attrs: {
      "icon": "el-icon-my-queding color-success",
      "type": "success",
      "plain": true
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus(_vm.id, 'entry')
      }
    }
  }, [_vm._v("进入入职\n                            ")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    attrs: {
      "icon": "el-icon-my-daochu color-info",
      "type": "info",
      "plain": true
    },
    on: {
      "click": _vm.exportFile
    }
  }, [_vm._v("\n                                导出简历\n                            ")])] : (_vm.from === 'paymentList') ? [_c('el-button', {
    attrs: {
      "icon": "el-icon-my-queding color-success",
      "type": "success",
      "plain": true
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus(_vm.id, 'pass')
      }
    }
  }, [_vm._v("接受Offer\n                            ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "icon": "el-icon-my-guanbi color-danger",
      "type": "danger",
      "plain": true
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus(_vm.id, 'fq')
      }
    }
  }, [_vm._v("放弃Offer\n                            ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "icon": "el-icon-my-huitui color-info",
      "type": "info",
      "plain": true
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus(_vm.id, 'back')
      }
    }
  }, [_vm._v("回退\n                            ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "icon": "el-icon-my-lahei color-purple",
      "type": "info",
      "plain": true
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus(_vm.id, 'lh')
      }
    }
  }, [_vm._v("拉黑\n                            ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "icon": "el-icon-my-daochu color-info",
      "type": "info",
      "plain": true
    },
    on: {
      "click": _vm.exportFile
    }
  }, [_vm._v("\n                                导出简历\n                            ")])] : _vm._e()], 2)], 1)], 1)], 1)]), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    class: [{
      'form-view': !_vm.isEdit
    }, 'form-switch'],
    attrs: {
      "span": 17
    }
  }, [_c('div', {
    staticClass: "box-shadow-small border-radius"
  }, [_c('personal-module', {
    key: _vm.preventKey + 1,
    ref: "personalModule",
    class: {
      'module-view': !_vm.isEdit
    },
    attrs: {
      "data": _vm.personalData
    }
  }), _vm._v(" "), _c('education-module', {
    key: _vm.preventKey + 2,
    ref: "educationModule",
    class: {
      'module-view': !_vm.isEdit
    },
    attrs: {
      "data": _vm.educationData
    }
  }), _vm._v(" "), _c('item-module', {
    key: _vm.preventKey + 3,
    ref: "workModule",
    class: {
      'module-view': !_vm.isEdit
    },
    attrs: {
      "type": "work",
      "multiple": true,
      "data": _vm.personalData.resumeWorkList
    }
  }), _vm._v(" "), _c('item-module', {
    key: _vm.preventKey + 4,
    ref: "projectModule",
    class: {
      'module-view': !_vm.isEdit
    },
    attrs: {
      "type": "project",
      "multiple": true,
      "data": _vm.personalData.resumeProjectList
    }
  }), _vm._v(" "), _c('item-module', {
    key: _vm.preventKey + 5,
    ref: "skillModule",
    class: {
      'module-view': !_vm.isEdit
    },
    attrs: {
      "type": "skill",
      "multiple": true,
      "data": _vm.personalData.resumeITSkillList
    }
  }), _vm._v(" "), _c('item-module', {
    key: _vm.preventKey + 6,
    ref: "experienceModule",
    class: {
      'module-view': !_vm.isEdit
    },
    attrs: {
      "type": "experience",
      "multiple": true,
      "data": _vm.personalData.resumeGameExperienceList
    }
  }), _vm._v(" "), _c('attach-module', {
    ref: "attachModule",
    class: {
      'module-view': !_vm.isEdit
    },
    attrs: {
      "data": _vm.attachData,
      "rid": _vm.rid
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 7
    }
  }, [_c('div', {
    staticClass: "box-shadow-small border-radius"
  }, [_c('div', {
    staticClass: "flow-step-module"
  }, [_c('h1', {
    staticClass: "module-title"
  }, [_vm._v("操作流转记录")]), _vm._v(" "), _c('div', {
    staticClass: "mt-20 flow-lists scrollbar-beauty"
  }, [(_vm.flowList.length) ? _c('el-steps', {
    attrs: {
      "space": 100,
      "direction": "vertical"
    }
  }, _vm._l((_vm.flowList), function(item, index) {
    return _c('el-step', {
      key: index,
      attrs: {
        "title": "",
        "icon": "el-icon-self-circle-icon"
      }
    }, [_c('div', {
      staticClass: "flow-info-box",
      attrs: {
        "slot": "description"
      },
      slot: "description"
    }, [(item.newPositionName || item.positionName) ? _c('p', {
      staticClass: "title"
    }, [_vm._v("\n                                        职位从 "), _c('span', {
      staticStyle: {
        "color": "#8c939d"
      }
    }, [_vm._v(_vm._s(item.positionName))]), _vm._v(" 变为 "), _c('span', {
      staticClass: "color-primary"
    }, [_vm._v(_vm._s(item.newPositionName))])]) : _c('p', {
      staticClass: "title"
    }, [_vm._v("\n                                        从 "), _c('span', {
      staticStyle: {
        "color": "#8c939d"
      }
    }, [_vm._v(_vm._s(_vm.getSelectMapText('WB_FLOW_STATUS', item.oldStatus) || '无'))]), _vm._v("\n                                        " + _vm._s(_vm.getStateDirect(item.oldStatus, item.newStatus)) + " "), _c('span', {
      staticClass: "color-success"
    }, [_vm._v(_vm._s(_vm.getSelectMapText('WB_FLOW_STATUS', item.newStatus)))])]), _vm._v(" "), _c('div', {
      staticClass: "clearfix ext-info",
      staticStyle: {
        "width": "100%"
      }
    }, [_c('p', {
      staticStyle: {
        "float": "left"
      }
    }, [_vm._v(_vm._s(item.operateTime))]), _vm._v(" "), _c('p', {
      staticStyle: {
        "float": "right"
      }
    }, [_vm._v("操作者：" + _vm._s(item.operatUser.name))])])])])
  }), 1) : _c('div', {
    staticStyle: {
      "color": "#c4c4c4",
      "text-align": "center"
    }
  }, [_vm._v("\n                            暂无数据\n                        ")])], 1)])])])], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fcd2b80e"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/resumeDetail/resumeDetail.vue
// module id = null
// module chunks = 